import { render, staticRenderFns } from "./DuplicateDatasetModal.vue?vue&type=template&id=b77e0cac"
import script from "./DuplicateDatasetModal.vue?vue&type=script&lang=js"
export * from "./DuplicateDatasetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports